import { useGetMetadataNetwork } from "../../api/currency";

export interface Root {
  id: string;
  name: string;
}

export const useMetadataNetwork = (currencyId?: number) => {
  const {
    data = {
      data: [],
    },
    isLoading,
  } = useGetMetadataNetwork(currencyId);

  const metadataNetwork = data.data.map((item: Root) => {
    return {
      value: item.id,
      label: item.name,
    };
  });
  return { metadataNetwork, dataNetwork: data.data, isLoading };
};
